import { ID, IdFilterType } from '../../../../../types';
import { FetchFinInvoicesFilters } from '../../../../../main/invoices/invoicesTypes';

export const enum UniversalFilterInvoicesModes {
  // CONTAINS_ANY_OF = 'contains_any_of'
  CONTAINS_ALL_OF = 'contains_all_of'
  // CONTAINS_ONLY = 'contains_only',
  // CONTAINS_NONE_OF = 'contains_none_of',
  // DOES_NOT_CONTAIN_ANY_OF = 'does_not_contain_any_of',
  // IS_EMPTY = 'is_empty',
  // IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterInvoicesValue = IdFilterType;

export type UniversalFilterInvoicesFilterState = {
  mode: UniversalFilterInvoicesModes;
  invoiceIds?: ID[];
};

export type UniversalFilterInvoicesFilterOptions = {
  initialInvoicesFilters?: FetchFinInvoicesFilters;
};

export type UniversalFilterInvoicesOnFilterStateChange = (
  state: UniversalFilterInvoicesFilterState
) => void;

export type UniversalFilterInvoicesOnChange = (
  value?: UniversalFilterInvoicesValue
) => void;
